var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDefault = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 52 52",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.005 49.25c12.84 0 23.25-10.41 23.25-23.25S38.845 2.75 26.005 2.75 2.755 13.16 2.755 26s10.41 23.25 23.25 23.25Zm0 2.583C40.273 51.833 51.84 40.268 51.84 26 51.839 11.732 40.273.167 26.005.167 11.738.167.172 11.732.172 26c0 14.268 11.566 25.833 25.833 25.833Z",
  fill: "#CEE1E8"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 41.022a2.62 2.62 0 0 1 2.325-2.61c9.965-1.102 16.43-1.003 26.373.025a2.571 2.571 0 0 1 1.431 4.485c-11.734 10.229-18.44 10.088-29.302.01a2.607 2.607 0 0 1-.827-1.909v-.001Z",
  fill: "#CEE1E8"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.076 39.721c-9.865-1.02-16.237-1.116-26.1-.024a1.327 1.327 0 0 0-1.174 1.326c0 .37.154.72.413.963 5.384 4.993 9.463 7.25 13.45 7.264 4.002.014 8.3-2.224 14.126-7.3a1.278 1.278 0 0 0-.715-2.227v-.002ZM12.693 37.13c10.07-1.115 16.63-1.014 26.65.023a3.861 3.861 0 0 1 2.147 6.744c-5.91 5.151-10.83 7.957-15.832 7.937-5.016-.018-9.72-2.871-15.198-7.954a3.9 3.9 0 0 1-1.241-2.857 3.911 3.911 0 0 1 3.474-3.894v.001Z",
  fill: "#CEE1E8"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M36.339 20.833a10.333 10.333 0 1 1-20.667 0 10.333 10.333 0 0 1 20.667 0Z",
  fill: "#CEE1E8"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.005 28.583a7.75 7.75 0 1 0 0-15.5 7.75 7.75 0 0 0 0 15.5Zm0 2.584a10.333 10.333 0 1 0 0-20.667 10.333 10.333 0 0 0 0 20.667Z",
  fill: "#CEE1E8"
})));
export default SvgDefault;